import { defineStore } from 'pinia';

export type ToastType = 'success' | 'info' | 'warning' | 'error';

export interface ToastAction {
  label: string;
  url: string;
}

export interface ToastItem {
  id: number;
  type: ToastType;
  message: string;
  detail?: string;
  action?: ToastAction;
}

export interface AppState {
  isOffline: boolean;
  toasts: ToastItem[];
  toastSeed: number;
}

export const useAppStore = defineStore('app', {
  state: (): AppState => ({
    isOffline: false,
    toasts: [],
    toastSeed: 0,
  }),
  actions: {
    setOffline(status: boolean) {
      this.isOffline = status;
    },
    pushToast(type: ToastType, message: string, detail?: string, action?: ToastAction) {
      const id = this.toastSeed++;
      this.toasts.push({ id, type, message, detail, action });

      // Automatically remove toast after 5 seconds (or 15 seconds if it has an action)
      setTimeout(
        () => {
          this.removeToast(id);
        },
        action ? 15000 : 5000,
      );
    },
    removeToast(id: number) {
      this.toasts = this.toasts.filter((t) => t.id !== id);
    },
  },
});
